export const VOTE_FOR_COW_REQUEST = 'VOTE_FOR_COW_REQUEST';
export const VOTE_FOR_COW_REQUEST_SUCCESS =
  'VOTE_FOR_COW_REQUEST_SUCCESS';
export const VOTE_FOR_COW_REQUEST_ERROR = 'VOTE_FOR_COW_REQUEST_ERROR';
export const RESET_LAST_VOTE_RESULT = 'RESET_LAST_VOTE_RESULT';